import { createContext } from 'react';
export const AdsSwappingContext = createContext({
  isFirstAdOnTop: true,
  handleScroll: () => {
    throw new Error('The handleScroll function is used out of the context provider!');
  },
  adLoadState: {
    r1: undefined,
    r2: undefined
  },
  setAdLoadState: () => {
    throw new Error('The setAdLoadState function is used out of the context provider!');
  }
});